module.exports = "img/voice-mute.c18eed0.svg";